// Helper canônico de validação de status de usuário.
// Mantém o mesmo contrato do backend (`is_user_active`).
//
// Permite acesso apenas para status:
//   - "ativo"
//   - "approved"
//
// Bloqueia: "pendente" / "Pendente" / "pending_approval" / "rejeitado"
//           / "inativo" / "suspenso" / vazio / qualquer outro valor.

export const ACTIVE_STATUS_VALUES = ["ativo", "approved"];

export function isUserActive(user) {
  if (!user) return false;
  const status = String(user.status || "").trim().toLowerCase();
  return ACTIVE_STATUS_VALUES.includes(status);
}

export function userBlockReason(user) {
  if (!user) return "not_authenticated";
  const status = String(user.status || "").trim().toLowerCase();
  if (ACTIVE_STATUS_VALUES.includes(status)) return null;
  if (status === "pending_approval" || status === "pendente") return "pending_approval";
  if (status === "rejeitado") return "rejected";
  if (status === "inativo") return "inactive";
  if (status === "suspenso") return "suspended";
  return "blocked";
}
